import React, { Component } from 'react';
import { connect } from 'react-redux';
import Translation from '../../utilities/localizationUtility';

class Index extends Component {
  renderPriceBlock(settings, totalPrice, t) {
    return(
      <p className="text-right">
        {this.props.title}
        <span className="bold ml10">
          {t.key('priceSymbol')}
          {(+totalPrice).toFixed(2)}
        </span>
      </p>
    )
  }

  renderAppointmentPriceBlock(settings, totalPrice, t) {
    return(
      <div className="price-line bt-1 mt0">
        <div className="price-currency">
          {this.props.title}
        </div>
        <div className="price">
          <span className="currency"> {t.key('priceSymbol')} </span>
          <span className="value"> {(+totalPrice).toFixed(2)} </span>
        </div>
      </div>
    )
  }


  render() {
    const { totalPrice, settings, widgetType } = this.props;
    const t = new Translation(settings);
    return (
      (widgetType == 'appt') ? this.renderAppointmentPriceBlock(settings, totalPrice, t) : this.renderPriceBlock(settings, totalPrice, t)
    );
  }
}

export default connect(({ order, settings }) => ({
  settings,
  totalPrice: +order.totalPrice * (order.quantity || 1),
}))(Index);
